import React from 'react';
import AntdModal from 'antd/lib/modal';
var Modal = /*#__PURE__*/React.memo(props => /*#__PURE__*/React.createElement(AntdModal, props));
export default Modal;